import { useEffect, useState } from 'react'

import { selectProcessDocumentContact } from '../../../store/processDocument/documentUsers'
import { selectProcessDocumentFileInfo } from '../../../store/processDocument/documentInfo'
import { selectDocumentType } from '../../../store/processDocument/documentSummary'
import { useLazyListAiAgentResultQuery } from '../../../store/ai/aiAgentResult'
import { selectAccountId } from '../../../store/auth/authSlice'
import { useAppSelector } from '../../../store/hooks'

import { AIAgentResult, AIAgentType } from '../../../models/AIAgent'

export const useDocumentSummaryIntegrationExport = () => {
  const accountId = useAppSelector(selectAccountId)
  const fileInfo = useAppSelector(selectProcessDocumentFileInfo)
  const contact = useAppSelector(selectProcessDocumentContact)
  const documentType = useAppSelector(selectDocumentType)

  const [triggerListAiAgentResults] = useLazyListAiAgentResultQuery()

  const [aiAgentResult, setAiAgentResult] = useState<AIAgentResult | null>(null)

  useEffect(() => {
    if (!contact || !documentType || !fileInfo) {
      return
    }

    const fetchAiAgentResult = async () => {
      try {
        const resultKey = `${contact.id}|${fileInfo.fileId}|${documentType.id}`
        const { data: aiAgentResult } = await triggerListAiAgentResults({ accountId, type: AIAgentType.DOCUMENT_SUMMARY, resultKey })
        if (!aiAgentResult?.length) {
          return
        }
        setAiAgentResult(aiAgentResult[0])
      } catch (e) {
        console.error(e)
      }
    }

    fetchAiAgentResult()
  }, [accountId, contact, documentType, fileInfo, triggerListAiAgentResults])

  return { aiAgentResult }
}
